import { DialogGeneral } from "../../utils/Dialog/dialog";
import { BASE_COLORS, createUUID, normalizeHexColor, showToolTipByElement, showStatusStack } from "../../utils/utils";
import '../../styles/treeTileModel.css'
import { IconArrowDown, IconCreateElement, IconCreateFolder, IconCreateRoot, IconCursorPosition, IconCursorRemove, IconDownLoad, IconEditElement, IconEyeHide, IconEyeShow, IconLink, IconRefresh, IconSave, IconSearch, IconTrash, IconUpload, IconFolder } from "../../icon";
import { Cartesian2, Cartesian3, Color, defined, DistanceDisplayCondition, EasingFunction, HeadingPitchRange, LabelStyle, ScreenSpaceEventHandler, ScreenSpaceEventType, VerticalOrigin, Viewer } from "cesium";
import '../../styles/labelPoint.css'
import { FormLabelPoint, InputForm } from "../Dialog/formLabelPoint";
import { getMessage } from "../../language";
import { DialogService, ETypeDialogService } from "../Dialog/serviceDialog";
import loadingGif from '../../assets/images/loading-roll-2.png'
import { ToolTipArrowType } from "../../interfaces/utils";
enum ButtonEnum {
    // Các ID từ button1s
    EditLabel,
    DownloadJson,
    UploadJson,

    // Các ID từ button2s
    CreateFolder,
    CreateRoot,
    CreateElement,
    UpdateCursorPosition,
    CursorRemove,
    ShowLabel,
    HideLabel,
    RemoveLabel,

    SaveDataLabel,
    RefreshDataLabel
}
enum ActionLabelEnum {
    CreateFolder,
    CreateLabel,
    CreateRoot,
    EditLabel,
    EditFolder,
    EditPointFolder

}

enum ActionListLabelPoint {
    ADD,
    DELETE,
    UPDATE,
}

interface Position {
    x: number;
    y: number;
    z: number;
}


interface DataLabelPoint {
    id: string | null;
    parentID: string | null; // Có thể là null
    name: string | null;
    url: string | null;
    fontSize: string | null;
    hexColor: string | null;
    expand: boolean | null;
    hasChild: boolean | null;
    position?: Position | null;
    isFolder?: boolean | null;
    cameraView: string | null; // Dữ liệu JSON string, bạn có thể dùng `CameraView` nếu parse trước
    ext?: string | null; // Phần mở rộng file
    displayName?: string | null; // Tên hiển thị khác với tên label
}

interface ActiveLabelPointEntity {
    idEntity: string;
    parentId: string | null;
    point?: any;
    name: string | null;
    displayName: string | null;
    url: string | null;
    camera: string | null;
}

export class LabelPoint {
    viewer: Viewer;
    containerId: string;
    IdGenneral = createUUID();//Tạo ID ngẫu nhiên khi khởi tạo
    dialog: DialogGeneral | undefined;
    listLabelPoint: DataLabelPoint[] = []
    formLabelPoint?: FormLabelPoint
    isDev = false
    isToggleBtnGroup = false
    listUrlLoad: string[] = []
    private onClosedCallback: ((status: boolean) => void) | undefined;
    callBackLabelPoint?: (data: { action: string; [key: string]: any }) => void | undefined


    constructor(containerId: string, viewer: Viewer) {
        this.containerId = containerId; // Gán giá trị containerId    
        this.viewer = viewer;//Gán giá trị viewer
        this.formLabelPoint = new FormLabelPoint(this.containerId, this.viewer)
        this.createModalTreeFolder();
        this.dialog?.showModal(false)


    }

    // Gán callback từ lớp cha
    setClosedCallback(callback: (status: boolean) => void): void {
        this.onClosedCallback = callback;
    }
    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean): void {
        if (this.onClosedCallback) {
            this.onClosedCallback(status); // Thông báo cho lớp cha
        } else {
            console.error("State change callback is not set.");
        }
    }

    //#region createModalTreeFolder
    createModalTreeFolder = () => {
        this.dialog = new DialogGeneral(
            this.containerId,
            this.handleCloseModal
        );
        this.dialog.innerHeader = getMessage('label-properties-title-dialog');
        this.dialog.modal = false
        this.dialog.minimizeDialog = true;
        this.dialog.widthModal = '350px'
        this.dialog.heightModal = '450px'
        this.dialog.minHeightModal = 350
        this.dialog.minWidthModal = 350
        // Lấy chuỗi HTML của tree view và gán cho innerBody
        this.dialog.innerBody = this.renderTreelabel(this.listLabelPoint);
        this.dialog.createDialog();
    }

    private handleCloseModal = (status: boolean) => {
        if (!status) {
            this.notifyCallBack(status)
            // this.showHideModalLabelProperties(false)

        }

    }

    showHideModalLabelProperties = (show: boolean) => {
        if (show) {
            this.activeHandleClickLabel()
            this.initKeyboardEvents()
            this.showHideAllLabelPoint(true)
            this.triggerChange({
                action: 'showModal',
                data: undefined
            })
        } else {
            this.resetClickLabelPoint()
            this.showHideAllLabelPoint(false)
            this.triggerChange({
                action: 'hideModal',
                data: undefined
            })
            this.resetData()
        }
        this.dialog?.showModal(show)
    }

    //#region triggerChange
    triggerChange = (data: any) => {
        if (this.callBackLabelPoint) {
            this.callBackLabelPoint(data);
        }
    }

    private containerUl: HTMLUListElement | undefined
    private containerLabel: HTMLDivElement | undefined
    private wrapperDiv: HTMLDivElement | undefined

    //#region Render Tree
    // Hàm renderTreeView đã sửa
    private renderTreelabel = (listLabelPoint: DataLabelPoint[]): HTMLElement => {

        // Nếu containerUl đã tồn tại, remove nó khỏi DOM
        const containerHost = document.getElementById(this.containerId);
        // Debug: report missing host or empty list (helps diagnose publish vs link differences)
        try {
            if (!containerHost) {
                console.warn(`LabelPoint(${this.IdGenneral}): container with id= ${this.containerId} not found in DOM`);
            }
            if (Array.isArray(listLabelPoint) && listLabelPoint.length === 0) {
                // no items to render
            } else if (Array.isArray(listLabelPoint) && listLabelPoint.length > 0) {
                console.debug(`LabelPoint(${this.IdGenneral}): rendering list of length ${listLabelPoint.length}`);
            }
        } catch (e) {
            // ignore
        }

        if (this.containerUl) {
            this.clearContainer();
        } else {
            // Tạo div bọc ngoài containerUl
            this.wrapperDiv = document.createElement('div');
            // stable id for debugging in production DOM
            this.wrapperDiv.id = `wrapper-label-${this.IdGenneral}`;
            this.wrapperDiv.className = "wrapper-container-label-point";

            this.wrapperDiv.appendChild(this.renderSearch())
            this.handleTrackInput();
            // Tạo lại containerUl mới
            this.containerUl = document.createElement('ul');
            this.containerUl.id = `label-point-${this.IdGenneral}`;
            this.containerUl.className = "container-treelist-label-point";


            // Thêm containerUl vào wrapperDiv
            this.wrapperDiv.appendChild(this.containerUl);

            // // Gắn wrapperDiv vào DOM (nếu cần)
            if (!this.containerLabel && this.isToggleBtnGroup) {
                this.renderBtnGroup();

            }
        }

        // Các mục có parentID == null hoặc không có parentID
        const rootItems = listLabelPoint.filter((item: DataLabelPoint) => item.parentID === null || item.parentID === undefined);
        // Thêm các phần tử con mới vào containerUl
        rootItems.forEach((dumy: DataLabelPoint) => {
            const fragment = this.createTreeItem(listLabelPoint, dumy);
            this.containerUl!.appendChild(fragment);
        });

        this.toggleButtonState(`create-element-${this.IdGenneral}`, false)
        this.toggleButtonState(`edit-label-${this.IdGenneral}`, false)
        this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, false)
        this.toggleButtonState(`trash-${this.IdGenneral}`, false)

        return this.wrapperDiv!;
    };
    //#region clearContainer
    private clearContainer = () => {
        if (this.containerUl) {
            while (this.containerUl.firstChild) {

                this.containerUl.removeChild(this.containerUl.firstChild);
            }
            // this.containerUl.innerHTML = ""; // Xóa nội dung bên trong containerUl
        }
    };
    //#region Create Tree
    private selectedItems: Set<string> = new Set(); // Lưu trữ các ID đã được chọn
    private lastSelectedItem: HTMLLIElement | null = null; // Lưu trữ mục cuối cùng được chọn (cho Shift chọn)
    private selectedRow?: DataLabelPoint
    /**
 * Tạo phần tử cây thư mục
 */
    private createTreeItem = (flatData: DataLabelPoint[], currentItem: DataLabelPoint): DocumentFragment => {
        const fragment = document.createDocumentFragment();
        // Tạo li chính cho item hiện tại
        const li = document.createElement('li');
        li.className = "dpu-tree-item";
        li.setAttribute('data-id', currentItem.id || "");

        // Tạo div chứa nền được chọn
        const fullrow = document.createElement('div');
        fullrow.className = "fullrow";

        // Thêm sự kiện chọn mục
        li.addEventListener('click', (event) => this.handleItemSelection(li, currentItem, event));

        // Tạo span chứa tên thư mục
        const span = this.createCaretSpan(currentItem);

        // Tìm các mục con
        const children = flatData.filter(item => item.parentID === currentItem.id);

        if (children.length > 0) {
            // Nếu có mục con, tạo arrow và nested container
            const { arrow, nestedUl } = this.createNestedContainer(currentItem, children, flatData);
            span.prepend(arrow); // Thêm arrow vào đầu span
            fragment.appendChild(li);
            fragment.appendChild(nestedUl);
        } else {
            // Nếu không có mục con, thêm placeholder
            const placeholder = document.createElement('span');
            placeholder.className = "arrow-placeholder";

            span.prepend(placeholder);
            fragment.appendChild(li);
        }

        // Thêm span và nút vào li
        const buttonContainer = this.createButtonContainer(currentItem, li);
        li.appendChild(fullrow);
        li.appendChild(span);
        li.appendChild(buttonContainer);

        return fragment;
    };

    //#region handleItemSelection
    /**
     * Xử lý sự kiện chọn mục
     */
    private handleItemSelection(li: HTMLLIElement, currentItem: DataLabelPoint, event?: MouseEvent): void {
        const isCtrl = event!.ctrlKey;
        const isShift = event!.shiftKey;

        if (isCtrl) {
            this.toggleSelectItem(li, currentItem);
            return;
        }

        if (isShift && this.lastSelectedItem) {
            this.selectRange(li, currentItem);
            return;
        }

        this.selectSingleItem(li, currentItem);
    }

    //#region toggleSelectItem
    /**
     * Chọn hoặc bỏ chọn mục (Ctrl)
     */
    private toggleSelectItem(li: HTMLLIElement, currentItem: DataLabelPoint): void {
        const isSelected = li.classList.toggle('active');
        //tắt Create
        this.toggleButtonState(`create-element-${this.IdGenneral}`, false)
        //tắt Edit
        this.toggleButtonState(`edit-label-${this.IdGenneral}`, false)
        this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, false)
        if (isSelected) {
            this.selectedItems.add(currentItem.id!);
        } else {
            this.selectedItems.delete(currentItem.id!);
        }
        if (this.selectedItems.size > 0) {
            this.toggleButtonState(`trash-${this.IdGenneral}`, true)
        } else {
            this.toggleButtonState(`trash-${this.IdGenneral}`, false)
        }
        if (this.selectedItems.size === 1) {
            //bât Create
            this.toggleButtonState(`create-element-${this.IdGenneral}`, true)
            //bât Edit
            this.toggleButtonState(`edit-label-${this.IdGenneral}`, true)
            this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, true)
            this.selectedRow = currentItem
        }
        this.lastSelectedItem = li;
    }

    //#region selectRange
    /**
     * Chọn một dải mục (Shift)
     */
    private selectRange(li: HTMLLIElement, currentItem: DataLabelPoint): void {
        //tắt Create
        this.toggleButtonState(`create-element-${this.IdGenneral}`, false)
        //tắt Edit
        this.toggleButtonState(`edit-label-${this.IdGenneral}`, false)

        this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, false)
        const allTreeItems = Array.from(this.containerUl!.querySelectorAll('.dpu-tree-item'));
        const currentIndex = allTreeItems.indexOf(li);
        const lastIndex = allTreeItems.indexOf(this.lastSelectedItem!);

        const [start, end] = [currentIndex, lastIndex].sort((a, b) => a - b);
        for (let i = start; i <= end; i++) {
            const item = allTreeItems[i] as HTMLLIElement;
            if (item && !item.classList.contains('active')) {
                item.classList.add('active');
                this.selectedItems.add(item.getAttribute('data-id')!);
            }
        }
        if (this.selectedItems.size > 0) {
            this.toggleButtonState(`trash-${this.IdGenneral}`, true);
        }
    }

    /**
     * Chọn một mục duy nhất
     */
    private selectSingleItem(li: HTMLLIElement, currentItem: DataLabelPoint): void {
        if (!this.activePickRemove) {
            //Bật Create     
            this.toggleButtonState(`create-element-${this.IdGenneral}`, true)
            //Bật Edit
            this.toggleButtonState(`edit-label-${this.IdGenneral}`, true)
            this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, true)

        }
        //Lưu lại dòng được chọn
        this.selectedRow = currentItem

        const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
        allTreeItems.forEach(item => item.classList.remove('active'));

        li.classList.add('active');
        this.selectedItems.clear();
        this.selectedItems.add(currentItem.id || "");
        this.toggleButtonState(`trash-${this.IdGenneral}`, true);
        this.lastSelectedItem = li;
    }

    private initKeyboardEvents(): void {
        document.addEventListener('keydown', (event) => this.handleSelectAll(event));

    }

    //#region handleSelectAll
    /**
     * Xử lý Ctrl+A để chọn tất cả
     */
    private handleSelectAll(event: KeyboardEvent): void {
        if (event.ctrlKey && event.key === 'a') {
            event.preventDefault();
            //tắt Create
            this.toggleButtonState(`create-element-${this.IdGenneral}`, false)
            //tắt Edit
            this.toggleButtonState(`edit-label-${this.IdGenneral}`, false)
            //tắt Update Position
            this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, false)
            const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
            allTreeItems.forEach(item => item.classList.add('active'));
            this.selectedItems.clear();
            allTreeItems.forEach(item => {
                this.selectedItems.add(item.getAttribute('data-id')!);
            });
            this.toggleButtonState(`trash-${this.IdGenneral}`, true);
        }
    }
    //#region createCaretSpan
    /**
     * Tạo span chứa caret và màu
     */
    private createCaretSpan(currentItem: DataLabelPoint): HTMLSpanElement {
        const span = document.createElement('span');
        span.className = "caret";

        const colorIndicator = document.createElement('span');
        if (currentItem?.isFolder !== undefined && currentItem.isFolder === true) {
            colorIndicator.className = "folder-icon-indicator";
            colorIndicator.innerHTML = IconFolder();

            // Set fill for SVG paths inside
            const pathElements = colorIndicator.querySelectorAll('path');
            pathElements.forEach(path => {
                path.setAttribute('fill', `${currentItem.hexColor}`);
            });
        } else {
            colorIndicator.className = "color-indicator";
            colorIndicator.style.backgroundColor = currentItem.hexColor!;
        }

        span.appendChild(colorIndicator);

        const textNode = document.createElement('span');
        textNode.className = "text";
        textNode.textContent = currentItem.displayName || currentItem.name;
        span.appendChild(textNode);

        return span;
    }

    //#region createNestedContainer
    /**
     * Tạo container cho mục con
     */
    private createNestedContainer(currentItem: DataLabelPoint, children: DataLabelPoint[], flatData: DataLabelPoint[]): { arrow: HTMLSpanElement, nestedUl: HTMLUListElement } {
        const arrow = document.createElement('span');
        arrow.className = "arrow-icon";
        arrow.innerHTML = IconArrowDown();

        const nestedUl = document.createElement('ul');
        nestedUl.className = "nested";

        if (currentItem.expand) {
            nestedUl.classList.add("active");
            arrow.classList.add("arrow-down");
        }

        children.forEach(childItem => {
            nestedUl.appendChild(this.createTreeItem(flatData, childItem));
        });
        //#region Arrow Click
        arrow.addEventListener("click", (event) => {

            this.handleToggleSelected(currentItem)
            event.stopPropagation();
            nestedUl.classList.toggle("active");
            arrow.classList.toggle("arrow-down");
        });

        return { arrow, nestedUl };
    }

    //#region handleToggleSelected
    private handleToggleSelected = (currentItem: DataLabelPoint) => {
        // console.log("currentItem", currentItem);
        const expandCurrentItem = this.listLabelPoint.find((label: DataLabelPoint) => label.id === currentItem.id)

        if (expandCurrentItem) {
            expandCurrentItem.expand = !expandCurrentItem.expand
            const listExpand = this.listLabelPoint.filter((label: DataLabelPoint) => this.selectedItems.has(label.id!))
            if (listExpand.length > 0) {
                listExpand.forEach((lable: DataLabelPoint) => {
                    lable.expand = expandCurrentItem.expand
                })
                this.selectedItems = new Set()
            }
        }
        this.renderTreelabel(this.listLabelPoint)
    }

    //#region createButtonContainer
    /**
     * Tạo container cho các nút chức năng (ví dụ: tìm kiếm, xóa, chỉnh sửa)
     */
    private createButtonContainer(currentItem: DataLabelPoint, li: HTMLLIElement): HTMLDivElement {
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'button-container';

        // Tạo nút liên kết
        const linkBtn = document.createElement('div');
        linkBtn.className = 'search-button';
        if (!currentItem.url) {
            linkBtn.classList.add('disabled')
        } else {
            linkBtn.classList.remove('disabled')
        }
        linkBtn.innerHTML = IconLink(); // Hàm tạo biểu tượng tìm kiếm
        linkBtn.addEventListener('click', (event) => {
            event.stopPropagation();
            this.handleItemSelection(li, currentItem, event)
            if (!currentItem.url) return
            window.open(currentItem.url, '_blank');
            // Làm nổi bật mục được chọn
            const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
            allTreeItems.forEach(item => item.classList.remove('active'));
            const parentLi = linkBtn.closest('.dpu-tree-item') as HTMLLIElement;
            parentLi?.classList.add('active');

        })
        buttonContainer.appendChild(linkBtn);

        // Tạo nút tìm kiếm
        const searchButton = document.createElement('div');
        searchButton.className = 'search-button';
        if (!currentItem.cameraView) {
            searchButton.classList.add('disabled')
        } else {
            searchButton.classList.remove('disabled')
        }
        searchButton.innerHTML = IconSearch(); // Hàm tạo biểu tượng tìm kiếm
        searchButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.handleItemSelection(li, currentItem, event)
            this.zoomLabelPoint(currentItem);

            // Làm nổi bật mục được chọn
            const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
            allTreeItems.forEach(item => item.classList.remove('active'));
            const parentLi = searchButton.closest('.dpu-tree-item') as HTMLLIElement;
            parentLi?.classList.add('active');
        });

        // Thêm nút vào container
        buttonContainer.appendChild(searchButton);


        return buttonContainer;
    }



    //#region renderSearch
    private searchInput: HTMLInputElement | null = null
    private listSearchLabelPoint: DataLabelPoint[] = []
    private isSearching: boolean = false
    private renderSearch = (): HTMLElement => {
        const groupSearch = document.createElement('div')
        groupSearch.style.display = 'flex'
        groupSearch.style.marginBottom = '5px'
        groupSearch.innerHTML = `
     
        <input class="dpu-input-text"  id="search-label-${this.IdGenneral}" type="text"  placeholder="${getMessage("label-properties-search")}"/>

        `

        return groupSearch
    }
    //#region handleTrackInput
    /**
   * Hàm theo dõi thay đổi của input  
   */
    private handleTrackInput = () => {
        this.searchInput = this.wrapperDiv!.querySelector(`#search-label-${this.IdGenneral}`)
        this.searchInput!.addEventListener("input", this.handleChangeSearchInput);
    }

    //#region handleChangeSearchInput
    /**
       * Theo dỗ giá trị input cho font size
       */
    private handleChangeSearchInput = () => {
        let searchValue = this.searchInput ? this.searchInput.value : "";
        if (searchValue.trim() === "") {
            //Nếu như rỗng thì trả về list nguyên bản
            this.renderTreelabel(this.listLabelPoint); // Render lại cây với danh sách đã lọc
            this.isSearching = false
            this.listSearchLabelPoint = []
            this.toggleButtonState(`create-element-${this.IdGenneral}`, false)
            this.toggleButtonState(`edit-label-${this.IdGenneral}`, false)
            this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, false);
        } else {
            this.isSearching = true
            //Render theo value search
            this.listSearchLabelPoint = this.searchListWithParents(searchValue, this.listLabelPoint); // Tìm kiếm danh sách phù hợp
            this.renderTreelabel(this.listSearchLabelPoint); // Render lại cây với danh sách đã lọc
        }
    }

    //#region searchListWithParents
    /**
 * Tìm kiếm các phần tử theo từ khóa và giữ lại các cha của chúng.
 * @param keyword Từ khóa tìm kiếm
 * @param list Danh sách đầy đủ để tìm kiếm
 * @returns Danh sách đã lọc bao gồm các phần tử phù hợp và các cha của chúng
 */
    private searchListWithParents(keyword: string, list: DataLabelPoint[]): DataLabelPoint[] {
        if (!keyword.trim()) {
            return list; // Nếu từ khóa trống, trả về danh sách đầy đủ
        }

        const lowerCaseKeyword = keyword.toLowerCase();
        const resultSet = new Set<DataLabelPoint>();

        // Hàm đệ quy tìm tất cả cha của một phần tử
        const findParents = (item: DataLabelPoint | undefined) => {
            if (!item || resultSet.has(item)) return;
            resultSet.add(item);
            const parent = list.find((parentItem) => parentItem.id === item.parentID);
            findParents(parent); // Gọi đệ quy tìm tiếp cha của cha
        };

        // Duyệt danh sách để tìm kiếm các phần tử phù hợp
        list.forEach((item) => {
            if (item.displayName && item.displayName.toLowerCase().includes(lowerCaseKeyword)) {
                findParents(item); // Tìm và thêm các cha của phần tử phù hợp
            }
        });

        return Array.from(resultSet); // Chuyển Set thành mảng
    }

    //#region Render Btn
    // Tạo các phần tử bên trong container1
    private button1s = [
        {
            id: `edit-label-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconEditElement(),
            tooltip: getMessage("label-point-edit"),
            show: true,
            disable: true,
            btnEnum: ButtonEnum.EditLabel,
            ToolTipArrowType: ToolTipArrowType.Top
        },
        {
            id: `download-json-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconDownLoad(),
            tooltip: getMessage("label-point-download-json"),
            show: true,
            disable: false,
            btnEnum: ButtonEnum.DownloadJson,
            ToolTipArrowType: ToolTipArrowType.Top
        },
        {
            id: `upload-json-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconUpload(),
            tooltip: getMessage("label-point-upload-json"),
            show: true,
            disable: false,
            btnEnum: ButtonEnum.UploadJson,
            ToolTipArrowType: ToolTipArrowType.Top
        },
    ];

    // Tạo các phần tử bên trong container2
    private button2s = [
        {
            id: `create-folder-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconCreateFolder(),
            tooltip: getMessage("label-point-create-folder"),
            show: true,
            disable: false,
            btnEnum: ButtonEnum.CreateFolder,
            ToolTipArrowType: ToolTipArrowType.Top
        },
        {
            id: `create-root-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconCreateRoot(),
            tooltip: getMessage("label-point-create-root"),
            show: true,
            disable: false,
            btnEnum: ButtonEnum.CreateRoot,
            ToolTipArrowType: ToolTipArrowType.Top
        },
        {
            id: `create-element-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconCreateElement(),
            tooltip: getMessage("label-point-create-element"),
            show: true,
            disable: true,
            btnEnum: ButtonEnum.CreateElement,
            ToolTipArrowType: ToolTipArrowType.Top
        },
        {
            id: `cursor-update-position-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconCursorPosition(),
            tooltip: getMessage("label-cursor-update-position"),
            show: true,
            disable: true,
            btnEnum: ButtonEnum.UpdateCursorPosition,
            ToolTipArrowType: ToolTipArrowType.Top
        },
        {
            id: `cursor-remove-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconCursorRemove(),
            tooltip: getMessage("label-point-cursor-remove"),
            show: true,
            disable: false,
            btnEnum: ButtonEnum.CursorRemove,
            ToolTipArrowType: ToolTipArrowType.Top
        },
        {
            id: `show-label-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconEyeShow(),
            tooltip: getMessage("label-point-show-all"),
            show: true,
            disable: false,
            btnEnum: ButtonEnum.ShowLabel,
            ToolTipArrowType: ToolTipArrowType.Top
        },
        {
            id: `hide-label-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconEyeHide(),
            tooltip: getMessage("label-point-hide-all"),
            show: false,
            disable: false,
            btnEnum: ButtonEnum.HideLabel,
            ToolTipArrowType: ToolTipArrowType.Top
        },
        {
            id: `trash-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconTrash(),
            tooltip: getMessage("label-point-remove-all"),
            show: true,
            disable: true,
            btnEnum: ButtonEnum.RemoveLabel,
            ToolTipArrowType: ToolTipArrowType.Top
        },
    ];
    private buttonDev = [
        {
            id: `refresh-label-point-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconRefresh(),
            tooltip: getMessage("label-point-refresh"),
            show: true,
            disable: false,
            btnEnum: ButtonEnum.RefreshDataLabel,
            ToolTipArrowType: ToolTipArrowType.Top
        },
        {
            id: `save-label-point-${this.IdGenneral}`,
            className: "btn-tool-labelPoint",
            icon: IconSave(),
            tooltip: getMessage("label-point-save"),
            show: true,
            disable: false,
            btnEnum: ButtonEnum.SaveDataLabel,
            ToolTipArrowType: ToolTipArrowType.Top
        },
    ];


    //#region renderBtnGroup
    renderBtnGroup = () => {
        if (this.containerUl) {
            this.containerUl.style.height = "calc(100% - 65px)"
        }
        // Tạo lại containerLabel mới
        this.containerLabel = document.createElement('div');
        this.containerLabel.className = "btn-group-point";
        const conatinerView = document.getElementById(this.containerId) as HTMLElement
        const div1 = document.createElement('div')

        // Tạo từng nút từ danh sách
        this.button1s.forEach(button => {

            const buttonDiv = document.createElement('button');
            buttonDiv.id = button.id;
            buttonDiv.className = `${button.className}${button.disable ? " disable" : ""}`; // Sử dụng template string để nối chuỗi
            if (!button.show) {
                buttonDiv.classList.add("hidden")
            }
            buttonDiv.disabled = button.disable
            buttonDiv.innerHTML = `${button.icon}`;
            buttonDiv.addEventListener('click', () => this.handleClickBtnAction(button.btnEnum))
            showToolTipByElement({ parentElement: conatinerView, childElement: buttonDiv, toolTip: button.tooltip, typeArrow: button.ToolTipArrowType })
            div1.appendChild(buttonDiv);

        });
        this.containerLabel.appendChild(div1)

        const div2 = document.createElement('div')
        // Tạo từng nút từ danh sách
        this.button2s.forEach(button => {

            const buttonDiv = document.createElement('button');
            buttonDiv.id = button.id;
            buttonDiv.className = `${button.className}${button.disable ? " disable" : ""}`; // Sử dụng template string để nối chuỗi
            if (!button.show) {
                buttonDiv.classList.add("hidden")
            }
            buttonDiv.disabled = button.disable
            buttonDiv.innerHTML = `${button.icon}`;
            buttonDiv.addEventListener('click', () => this.handleClickBtnAction(button.btnEnum))
            showToolTipByElement({ parentElement: conatinerView, childElement: buttonDiv, toolTip: button.tooltip, typeArrow: button.ToolTipArrowType })

            div2.appendChild(buttonDiv);

        });
        this.containerLabel.appendChild(div2)

        if (this.isDev) {
            this.buttonDev.forEach(button => {
                const buttonDiv = document.createElement('button');
                buttonDiv.id = button.id;
                buttonDiv.className = `${button.className}${button.disable ? " disable" : ""}`; // Sử dụng template string để nối chuỗi
                if (!button.show) {
                    buttonDiv.classList.add("hidden")
                }
                buttonDiv.disabled = button.disable
                buttonDiv.innerHTML = `${button.icon}`;
                buttonDiv.addEventListener('click', () => this.handleClickBtnAction(button.btnEnum))
                showToolTipByElement({ parentElement: conatinerView, childElement: buttonDiv, toolTip: button.tooltip, typeArrow: button.ToolTipArrowType })
                div1.appendChild(buttonDiv);
            })
        }

        this.wrapperDiv?.appendChild(this.containerLabel)


    };





    //#region toggleButtonState
    //Hàm tắt bật trạng thái hoạt động hay không cho nút
    private toggleButtonState = (id: string, isEnabled: boolean): void => {
        const button = document.querySelector(`#${id}`) as HTMLButtonElement;
        if (!button) {
            return;
        }

        if (isEnabled) {
            button.disabled = false;
            button.classList.remove('disable');

        } else {

            button.disabled = true;
            button.classList.add('disable');

        }
    };

    private toggleButtonsState = (isEnabled: boolean): void => {
        const buttons = [...this.button1s, ...this.button2s];
        buttons.forEach(button => {
            this.toggleButtonState(button.id, isEnabled);
            // const buttonElement = document.querySelector(`#${button.id}`) as HTMLButtonElement;


            // if (buttonElement) {
            // if (isEnabled) {
            //     buttonElement.disabled = false;
            //     buttonElement.classList.remove('disable');

            // } else {
            //     buttonElement.disabled = true;
            //     buttonElement.classList.add('disable');
            // }
            // }
        });
    }


    private activePickRemove: boolean = false
    //#region Btn Action
    private handleClickBtnAction = (btnEnum: ButtonEnum) => {
        switch (btnEnum) {
            case ButtonEnum.CreateFolder:
                this.toggtleShowHideLabelPoint(true)
                this.dialog?.showModal(false)
                this.formLabelPoint!.forFoler = true
                this.formLabelPoint!.createModalLabelPoint()

                this.formLabelPoint!.showHideModalLabelPoint(true)
                this.handleCallBackFormLabelPoint(ActionLabelEnum.CreateFolder)
                this.clearSelection()

                break;
            case ButtonEnum.EditLabel:
                this.dialog?.showModal(false)
                this.toggtleShowHideLabelPoint(true)
                const itemEdit = this.listLabelPoint.find((x: DataLabelPoint) => x.id === this.selectedRow!.id)
                if (itemEdit) {
                    const labelPoint: InputForm = {
                        displayName: itemEdit!.displayName || itemEdit!.name || "",
                        name: itemEdit!.name || "",
                        url: itemEdit!.url || "",
                        fontSize: itemEdit!.fontSize ? Number(itemEdit!.fontSize) : 14,
                        hexColor: itemEdit!.hexColor ? normalizeHexColor(itemEdit!.hexColor!) : "",
                    }

                    this.formLabelPoint!.inputForm = labelPoint
                    if (itemEdit!.isFolder) {
                        this.formLabelPoint!.isEditFolder = true
                        this.handleCallBackFormLabelPoint(ActionLabelEnum.EditFolder)
                    } else {
                        if (itemEdit!.parentID) {
                            this.formLabelPoint!.isEditLabel = true
                            this.handleCallBackFormLabelPoint(ActionLabelEnum.EditLabel)
                        } else {
                            this.formLabelPoint!.isEditPointFolder = true
                            this.handleCallBackFormLabelPoint(ActionLabelEnum.EditPointFolder)
                        }
                    }
                    this.formLabelPoint!.createModalLabelPoint()
                }

                break;
            case ButtonEnum.DownloadJson:
                this.downloadJson()

                break;
            case ButtonEnum.UploadJson:
                this.uploadJson()
                break;
            case ButtonEnum.CreateRoot:
                this.toggtleShowHideLabelPoint(true)
                this.dialog?.showModal(false)
                this.formLabelPoint!.createModalLabelPoint()
                this.formLabelPoint!.showHideModalLabelPoint(true)
                this.handleCallBackFormLabelPoint(ActionLabelEnum.CreateRoot)
                this.clearSelection()
                break;


            case ButtonEnum.CreateElement:
                {
                    const parentRow = this.selectedRow;
                    this.toggtleShowHideLabelPoint(true)

                    this.dialog?.showModal(false)
                    this.formLabelPoint!.createModalLabelPoint()
                    this.handleCallBackFormLabelPoint(ActionLabelEnum.CreateLabel, parentRow)
                    this.clearSelection()
                }
                break;
            case ButtonEnum.UpdateCursorPosition:
                this._updatePositionByPick()
                break;

            case ButtonEnum.CursorRemove:
                this.activePickRemove = !this.activePickRemove
                const button = this.containerLabel?.querySelector(`#cursor-remove-${this.IdGenneral}`) as HTMLButtonElement;
                if (this.activePickRemove) {

                    this.toggleButtonsState(false)
                    this.toggtleShowHideLabelPoint(true)

                    this.toggleButtonState(`cursor-remove-${this.IdGenneral}`, true)
                    button.classList.add('active');
                } else {
                    this.toggleButtonsState(true)

                    if (!this.selectedRow) {
                        this.toggleButtonState(`create-element-${this.IdGenneral}`, false)
                        this.toggleButtonState(`edit-label-${this.IdGenneral}`, false)
                        this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, false);
                    }
                    button.classList.remove('active');

                }
                this.removeByPickLabelPoint(this.activePickRemove)
                break;
            case ButtonEnum.ShowLabel:


                this.toggtleShowHideLabelPoint(false)
                break;
            case ButtonEnum.HideLabel:



                this.toggtleShowHideLabelPoint(true)

                break;
            case ButtonEnum.RemoveLabel:

                this.removeLabelPointBySelected()
                break;

            case ButtonEnum.SaveDataLabel:

                this.triggerChange({
                    action: 'saveData',
                    data: this.listLabelPoint
                })

                break;

            case ButtonEnum.RefreshDataLabel:
                this.triggerChange({
                    action: 'loadData',
                    data: this // Trả ra chính class đang tạo
                });

                break;
            default:
                console.error("Hành động không xác định");
        }
    }


    //#region toggtleShowHideLabelPoint
    private toggtleShowHideLabelPoint = (show: boolean) => {
        if (show) {
            this.wrapperDiv?.querySelector(`#show-label-${this.IdGenneral}`)?.classList.remove("hidden")
            this.wrapperDiv?.querySelector(`#hide-label-${this.IdGenneral}`)?.classList.add("hidden")
            if (this.statusStackRef) {
                this.statusStackRef.remove();
                this.statusStackRef = undefined;
            }
        } else {
            this.wrapperDiv?.querySelector(`#show-label-${this.IdGenneral}`)?.classList.add("hidden")
            this.wrapperDiv?.querySelector(`#hide-label-${this.IdGenneral}`)?.classList.remove("hidden")
            if (this.statusStackRef) {
                this.statusStackRef.remove();
            }
            this.statusStackRef = showStatusStack(this.containerId, getMessage("label-point-hide-all-state"));
        }
        this.showHideAllLabelPoint(show)
    }

    //Hàm Update ListLabelPoint
    //#region  handleUpdateListLabelPoint
    private handleUpdateListLabelPoint = (dataLabel: DataLabelPoint, action: ActionListLabelPoint) => {
        switch (action) {
            case ActionListLabelPoint.ADD:

                if (dataLabel.parentID !== null || dataLabel.parentID !== undefined) {
                    const item = this.listLabelPoint.find((x: DataLabelPoint) => x.id === dataLabel.parentID)
                    if (item) {
                        item.hasChild = true
                        item.expand = dataLabel.expand
                    }
                }

                this.listLabelPoint.push(dataLabel)
                if (this.isSearching) {
                    this.listSearchLabelPoint.push(dataLabel)
                }
                this.viewer.scene.requestRender();

                break;
            case ActionListLabelPoint.DELETE:

                this.deleteLabelFormListById(dataLabel.id)
                this.viewer.scene.requestRender();


                break;

            case ActionListLabelPoint.UPDATE:
                this.editLabelPoint(dataLabel)
                this.viewer.scene.requestRender();

                break;

            default:
                break;

        }

        if (this.isSearching) {
            this.renderTreelabel(this.listSearchLabelPoint)
        } else {
            this.renderTreelabel(this.listLabelPoint)

        }
    }
    //#region resetData
    private resetData = () => {
        this.toggleButtonsState(true)
        this.wrapperDiv?.querySelector(`#show-label-${this.IdGenneral}`)?.classList.remove("hidden")
        this.wrapperDiv?.querySelector(`#hide-label-${this.IdGenneral}`)?.classList.add("hidden")
        if (this.selectedRow) {
            this.toggleButtonState(`create-element-${this.IdGenneral}`, true)
            this.toggleButtonState(`edit-label-${this.IdGenneral}`, true)
            this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, true);
            this.toggleButtonState(`trash-${this.IdGenneral}`, true);
        } else {
            this.toggleButtonState(`create-element-${this.IdGenneral}`, false)
            this.toggleButtonState(`edit-label-${this.IdGenneral}`, false)
            this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, false);
            this.toggleButtonState(`trash-${this.IdGenneral}`, false);
        }
        const button = this.containerLabel?.querySelector(`#cursor-remove-${this.IdGenneral}`) as HTMLButtonElement;
        button?.classList.remove('active');
        this.activePickRemove = false

    }

    private clearSelection = () => {
        this.selectedItems.clear();
        this.selectedRow = undefined;
        this.lastSelectedItem = null;
        if (this.containerUl) {
            const allTreeItems = this.containerUl.querySelectorAll('.dpu-tree-item');
            allTreeItems.forEach(item => item.classList.remove('active'));
        }
        this.toggleButtonState(`create-element-${this.IdGenneral}`, false);
        this.toggleButtonState(`edit-label-${this.IdGenneral}`, false);
        this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, false);
        this.toggleButtonState(`trash-${this.IdGenneral}`, false);
    }

    private activeLabelPointEntities: { [key: string]: ActiveLabelPointEntity } = {};
    private isClickLabelPoint?: ScreenSpaceEventHandler
    //#region activeHandleClickLabel
    private activeHandleClickLabel = () => {
        if (!this.isClickLabelPoint) {
            this.isClickLabelPoint = new ScreenSpaceEventHandler(this.viewer.canvas);
        }
        this.isClickLabelPoint.setInputAction(async (click: ScreenSpaceEventHandler.PositionedEvent) => {
            const pickedObject = this.viewer.scene.pick(click.position);
            if (defined(pickedObject) && pickedObject.id && pickedObject) {
                const entityId = pickedObject.id.id; // Lấy ID của entity được chọn
                if (this.activeLabelPointEntities[entityId]) {
                    const url = this.activeLabelPointEntities[entityId].url; // Truy cập URL từ entity
                    // Hiển thị xác nhận trước khi mở URL
                    if (!url) return

                    const dialog = new DialogService({
                        containerId: this.containerId,
                        typeDialog: ETypeDialogService.Info,
                        inputModal: {
                            contentHeader: getMessage("dialog-service-open-link-header"),
                            contentBody: getMessage("dialog-service-open-link-content")
                        }
                    });

                    // Chờ đợi người dùng nhấn nút OK hoặc Cancel
                    await dialog.showModalAndWait();
                    if (dialog._action === "Ok") {
                        // Người dùng nhấn OK, mở URL
                        window.open(url, '_blank'); // Mở URL trong tab mới
                    } else {
                        console.error("Người dùng hủy mở liên kết.");
                    }
                }
            }
            this.viewer.scene.requestRender();

        }, ScreenSpaceEventType.LEFT_CLICK)
    }
    //#region _updatePositionByPick
    private _updatePositionByPick = async () => {
        if (this.selectedRow === undefined || this.selectedRow === null) { return; }
        if (!this.selectedRow.id) { return; }
        this.dialog?.showModal(false)
        // const entityUpdate = this.activeLabelPointEntities[this.selectedRow.id];
        this.createPointWithLabel(this.selectedRow, this.selectedRow.parentID)



    }

    private handelClickRemoveLabelPoint?: ScreenSpaceEventHandler
    //#region removeByPickLabelPoint
    //Hàm remove khi pick đối tượng
    private removeByPickLabelPoint(activePick: boolean) {
        this.resetClickLabelPoint()
        if (activePick) {
            this.showTooltipOnMouseMove("issue-point-tool-tip-remove");

            if (this.statusStackRef) {
                this.statusStackRef.remove();
            }
            this.statusStackRef = showStatusStack(this.containerId, getMessage("label-point-remove-state"));

            this.handelClickRemoveLabelPoint = new ScreenSpaceEventHandler(this.viewer.canvas);
            this.handelClickRemoveLabelPoint.setInputAction(async (event: ScreenSpaceEventHandler.PositionedEvent) => {
                const pickedEntity = this.viewer.scene.pick(event.position);
                if (defined(pickedEntity) && defined(pickedEntity.id)) {
                    // Lấy phần entityId mà không có hậu tố
                    const fullEntityId = pickedEntity.id.id;

                    const dialog = new DialogService({
                        containerId: this.containerId,
                        typeDialog: ETypeDialogService.Warning,
                        inputModal: {
                            contentHeader: getMessage("dialog-service-question-remove-header"),
                            contentBody: getMessage("dialog-service-question-remove-content")
                        }
                    });

                    // Chờ đợi người dùng nhấn nút OK hoặc Cancel
                    await dialog.showModalAndWait();
                    if (dialog._action === "Ok") {
                        this.removeLabelPoint(fullEntityId)
                        this.handleUpdateListLabelPoint(fullEntityId, ActionListLabelPoint.DELETE)
                        this.selectedRow = undefined  //Xóa dòng được chọn
                    } else {
                        console.error("Người dùng hủy mở liên kết.");
                    }

                } this.viewer.scene.requestRender();


            }, ScreenSpaceEventType.LEFT_CLICK)
        } else {
            this.activeHandleClickLabel()
        }

    }

    private showTooltipOnMouseMove = (messageKey: Parameters<typeof getMessage>[0]) => {
        let mouseX = 0;
        let mouseY = 0;

        this.onMouseMoveTooltip = (e: MouseEvent) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
            if (this.tooltipDiv) {
                this.tooltipDiv.style.left = `${e.clientX + 15}px`;
                this.tooltipDiv.style.top = `${e.clientY + 15}px`;
            }
        };
        document.addEventListener('mousemove', this.onMouseMoveTooltip);

        this.tooltipTimeout = setTimeout(() => {
            if (!this.tooltipDiv) {
                this.tooltipDiv = document.createElement('div');
                this.tooltipDiv.className = 'DPU-tooltip-mouse-move';
                this.tooltipDiv.style.display = 'block';
                this.tooltipDiv.style.position = 'fixed';
                this.tooltipDiv.style.zIndex = '9999';
                this.tooltipDiv.innerText = getMessage(messageKey);

                this.tooltipDiv.style.left = `${mouseX + 15}px`;
                this.tooltipDiv.style.top = `${mouseY + 15}px`;
                
                const parent = document.getElementById(this.containerId) || document.body;
                parent.appendChild(this.tooltipDiv);
            }
        }, 2000);
    }

    private tooltipTimeout?: number | NodeJS.Timeout;
    private tooltipDiv?: HTMLDivElement;
    private onMouseMoveTooltip?: (e: MouseEvent) => void;

    private resetClickLabelPoint = () => {
        // Remove any click handlers used for creating/updating/removing label points
        if (this.handlerClickCreateLabelPoint) {
            try { this.handlerClickCreateLabelPoint.removeInputAction(ScreenSpaceEventType.LEFT_CLICK); } catch (e) { }
            try { this.handlerClickCreateLabelPoint.destroy(); } catch (e) { }
            this.handlerClickCreateLabelPoint = undefined;
        }

        if (this.isClickLabelPoint) {
            try { this.isClickLabelPoint.removeInputAction(ScreenSpaceEventType.LEFT_CLICK); } catch (e) { }
            try { this.isClickLabelPoint.destroy(); } catch (e) { }
            this.isClickLabelPoint = undefined;
        }

        if (this.handelClickRemoveLabelPoint) {
            try { this.handelClickRemoveLabelPoint.removeInputAction(ScreenSpaceEventType.LEFT_CLICK); } catch (e) { }
            try { this.handelClickRemoveLabelPoint.destroy(); } catch (e) { }
            this.handelClickRemoveLabelPoint = undefined;
        }

        // Clean up tooltip
        if (this.tooltipTimeout) {
            clearTimeout(this.tooltipTimeout);
            this.tooltipTimeout = undefined;
        }
        if (this.onMouseMoveTooltip) {
            document.removeEventListener('mousemove', this.onMouseMoveTooltip);
            this.onMouseMoveTooltip = undefined;
        }
        if (this.tooltipDiv) {
            this.tooltipDiv.remove();
            this.tooltipDiv = undefined;
        }

        if (this.statusStackRef) {
            this.statusStackRef.remove();
            this.statusStackRef = undefined;
        }

        // Remove global keydown listener added during create/update flows
        try { document.removeEventListener("keydown", this.handleDocumentEventsLabelPoint); } catch (e) { }

        // Reset event active flag
        this.isEventActive = false;
    }



    //#region createLabelPointFromUrl
    private handlerClickCreateLabelPoint?: ScreenSpaceEventHandler

    createLabelPointFromUrl = async (linkUrl: string, fromJson: boolean = false, dataJson: unknown, isShow: boolean = false): Promise<DataLabelPoint[]> => {
        try {
            let labelPoints
            if (!fromJson) {
                const checkUrl = this.listUrlLoad.find((x: string) => x === linkUrl)
                if (checkUrl) {
                    this._renderLoading(false)
                    return []
                }
                this.listUrlLoad.push(linkUrl)
                // Tải dữ liệu JSON từ URL
                this._renderLoading(true)

                const response = await fetch(linkUrl);

                // Kiểm tra xem phản hồi có thành công không
                if (!response.ok) {
                    throw new Error(`Failed to fetch JSON from ${linkUrl}: ${response.statusText}`);
                }

                // Parse dữ liệu JSON
                labelPoints = await response.json();
            } else {

                labelPoints = dataJson

            }
            const distanceCam = 2000;

            // Kiểm tra nếu mảng labelPoints có dữ liệu
            if (labelPoints && labelPoints.length > 0) {
                labelPoints.forEach((labelPoint: DataLabelPoint) => {
                    let point
                    if (labelPoint.isFolder === undefined || !labelPoint.isFolder) {
                        if (labelPoint.cameraView) {

                            point = this.viewer.entities.add({
                                id: labelPoint.id || undefined, // Đảm bảo ID là duy nhất
                                position: new Cartesian3(labelPoint.position!.x, labelPoint.position!.y, labelPoint.position!.z),
                                point: {
                                    color: Color.fromCssColorString(labelPoint.hexColor!),
                                    pixelSize: 12,
                                    outlineColor: Color.WHITE,
                                    outlineWidth: 2,
                                    disableDepthTestDistance: Number.POSITIVE_INFINITY,
                                    distanceDisplayCondition: new DistanceDisplayCondition(0.0, distanceCam),
                                },
                                label: {
                                    text: labelPoint.displayName!, // Đảm bảo rằng labelPoint có thuộc tính displayName
                                    font: `${labelPoint.fontSize}px sans-serif`,
                                    fillColor: Color.WHITE,
                                    style: LabelStyle.FILL_AND_OUTLINE,
                                    disableDepthTestDistance: Number.POSITIVE_INFINITY,
                                    distanceDisplayCondition: new DistanceDisplayCondition(0.0, distanceCam),
                                    outlineWidth: 2,
                                    verticalOrigin: VerticalOrigin.BOTTOM,
                                    pixelOffset: new Cartesian2(0, -15),
                                    backgroundColor: new Color(0.0, 0.0, 0.0, 0.5),
                                    showBackground: true,
                                }
                            });

                            //Ẩn point đi
                            point.show = isShow;
                            // Tạo một point để hiển thị vị trí đã pick trên bề mặt

                        }
                    }

                    // Lưu lại thông tin các đối tượng điểm
                    this.activeLabelPointEntities[labelPoint.id!] = {
                        idEntity: labelPoint.id!,
                        parentId: labelPoint.parentID,
                        point: point,
                        displayName: labelPoint.displayName || labelPoint.name,
                        name: labelPoint.name,
                        url: labelPoint.url,
                        camera: labelPoint.cameraView,
                    };

                    // Thêm labelPoint vào listLabelPoint
                    if (!fromJson) {
                        labelPoint.expand = false
                        this.handleUpdateListLabelPoint(labelPoint, ActionListLabelPoint.ADD)
                    }
                });
            } else {
                this._renderLoading(false)

            }

            return labelPoints;

        } catch (error) {
            console.warn("Error fetching or parsing JSON:", error);
            this._renderLoading(false)

            // Trả về một mảng rỗng nếu xảy ra lỗi
            return [];
        }
    };

    //#region createPointWithLabel
    private isEventActive: boolean = false; // Cờ kiểm soát sự kiện
    statusStackRef?: { remove: () => void };
    private createPointWithLabel = (dataLabel: DataLabelPoint, parentId: string | null) => {

        //khoảng cách Point nhìn thấy được Camera khi zoom
        const distanceCam = 2000
        //góc nhìn
        let currentView: string | null = null
        this.resetClickLabelPoint();

        this.showTooltipOnMouseMove("label-point-tooltip-select");

        if (this.statusStackRef) {
            this.statusStackRef.remove();
        }
        const isUpdate = dataLabel?.id && this.activeLabelPointEntities[dataLabel.id];
        const stateMessage = isUpdate ? getMessage("label-point-update-position-state") : getMessage("label-point-state");
        this.statusStackRef = showStatusStack(this.containerId, stateMessage);

        document.addEventListener("keydown", this.handleDocumentEventsLabelPoint);

        this.handlerClickCreateLabelPoint = new ScreenSpaceEventHandler(this.viewer.canvas);

        this.handlerClickCreateLabelPoint.setInputAction((event: ScreenSpaceEventHandler.PositionedEvent) => {

            var cartesian;
            // Sử dụng pickPosition để lấy tọa độ chính xác trên bề mặt đối tượng hoặc địa hình
            cartesian = this.viewer.scene.pickPosition(event.position);
            if (!cartesian) {
                alert(getMessage("label-point-click-position-is-incorrect"))
                return
            }

            if (cartesian) {
                // Sử dụng drillPick để kiểm tra vật thể
                var pickedObject = this.viewer.scene.drillPick(event.position);

                if (pickedObject.length == 0) {
                    var ray = this.viewer.camera.getPickRay(event.position);
                    cartesian = ray ? this.viewer.scene.globe.pick(ray, this.viewer.scene) : undefined;
                }


                let entityIdBase = dataLabel?.id || createUUID()
                const findEntity = this.activeLabelPointEntities[entityIdBase];
                if (findEntity) {
                    this.removeLabelPoint(entityIdBase)


                }

                if (defined(cartesian)) {
                    // Tạo một point để hiển thị vị trí đã pick trên bề mặt
                    let point = this.viewer.entities.add({
                        id: entityIdBase, // Đảm bảo ID là duy nhất
                        position: cartesian,
                        point: {
                            color: Color.fromCssColorString(dataLabel.hexColor || "#F4B400"),
                            pixelSize: 12,
                            outlineColor: Color.WHITE,
                            outlineWidth: 2,
                            disableDepthTestDistance: Number.POSITIVE_INFINITY,
                            distanceDisplayCondition: new DistanceDisplayCondition(0.0, distanceCam),
                        },
                        label: {
                            text: dataLabel.displayName || dataLabel.name || "", // Sử dụng displayName nếu có, nếu không thì dùng name
                            font: `${dataLabel.fontSize}px sans-serif`,
                            fillColor: Color.WHITE,
                            style: LabelStyle.FILL_AND_OUTLINE,
                            disableDepthTestDistance: Number.POSITIVE_INFINITY, // Vô hiệu hóa kiểm tra chiều sâu để nhãn luôn hiển thị
                            distanceDisplayCondition: new DistanceDisplayCondition(0.0, distanceCam),
                            outlineWidth: 2,
                            verticalOrigin: VerticalOrigin.BOTTOM,
                            pixelOffset: new Cartesian2(0, -15),
                            backgroundColor: new Color(0.0, 0.0, 0.0, 0.5), // Màu nền đen với độ trong suốt
                            showBackground: true // Hiển thị nền
                        }
                    });
                    //Lưu lại góc nhìn
                    currentView = this.saveCurrentView();

                    this.activeLabelPointEntities[entityIdBase] = {
                        idEntity: entityIdBase,
                        parentId: parentId,
                        point: point,
                        name: dataLabel.name,
                        displayName: dataLabel.displayName || dataLabel.name,
                        url: dataLabel.url,
                        camera: currentView
                    }

                    if (!dataLabel?.isFolder || dataLabel?.isFolder === undefined || dataLabel?.isFolder === null) {

                        let objLabel: DataLabelPoint = {
                            id: entityIdBase,
                            parentID: parentId,
                            name: dataLabel.name,
                            displayName: dataLabel.displayName || dataLabel.name,
                            url: dataLabel.url,
                            fontSize: dataLabel.fontSize,
                            hexColor: dataLabel.hexColor,
                            expand: true,
                            hasChild: parentId ? true : false,
                            position: {
                                x: cartesian.x,
                                y: cartesian.y,
                                z: cartesian.z
                            },
                            cameraView: currentView

                        }
                        if (!findEntity) {

                            this.handleUpdateListLabelPoint(objLabel, ActionListLabelPoint.ADD)
                        } else {
                            let findIndex = this.listLabelPoint.findIndex((x: DataLabelPoint) => x.id === entityIdBase)
                            if (findIndex !== -1) {
                                this.listLabelPoint[findIndex] = { ...objLabel }
                                this.renderTreelabel(this.listLabelPoint)

                            }
                        }

                    } else {
                        const checkItem = this.listLabelPoint.find((x: DataLabelPoint) => x.id === this.selectedRow?.id)
                        if (checkItem) {
                            checkItem.expand = true
                            checkItem.position = {
                                x: cartesian.x,
                                y: cartesian.y,
                                z: cartesian.z
                            }
                            checkItem.cameraView = currentView

                            this.dialog?.showModal(true)

                            checkItem.isFolder = false
                        }
                    }
                } else {
                    console.error("Không thể pick vị trí trên bề mặt hoặc vật thể.");
                }
            }
            // Gỡ sự kiện click ngay sau khi xử lý
            if (this.handlerClickCreateLabelPoint) {
                this.handlerClickCreateLabelPoint.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
                this.handlerClickCreateLabelPoint.destroy();
                this.handlerClickCreateLabelPoint = undefined; // Xóa tham chiếu
                this.activeHandleClickLabel()
            }

            // Hủy các sự kiện chuột và phím
            this.removeDocumentEvents();

            this.viewer.scene.requestRender();

        }, ScreenSpaceEventType.LEFT_CLICK);



    }

    //#region createFolderLabelPoint
    private createFolderLabelPoint = (dataLabel: DataLabelPoint) => {

        //góc nhìn
        let currentView = this.saveCurrentView();
        // document.addEventListener("keydown", this.handleDocumentEventsLabelPoint);
        const entityIdBase = createUUID()
        this.activeLabelPointEntities[entityIdBase] = {
            idEntity: entityIdBase,
            parentId: null,
            point: undefined,
            name: dataLabel.name,
            displayName: dataLabel.displayName || dataLabel.name,
            url: dataLabel.url,
            // isShow:true,
            camera: currentView,
        }


        let objLabel: DataLabelPoint = {
            id: entityIdBase,
            parentID: null,
            displayName: dataLabel.displayName || dataLabel.name,
            name: dataLabel.name,
            url: "",
            fontSize: "14",
            hexColor: dataLabel.hexColor,
            expand: true,
            hasChild: false,
            position: undefined,
            cameraView: currentView,
            isFolder: true


        }
        this.handleUpdateListLabelPoint(objLabel, ActionListLabelPoint.ADD)


    }

    //Sự kiên theo dỗi khi hủy nút bấm
    private removeDocumentEvents = () => {

        this.dialog?.showModal(true)
        document.removeEventListener("keydown", this.handleDocumentEventsLabelPoint);

        // Clean up tooltip
        if (this.tooltipTimeout) {
            clearTimeout(this.tooltipTimeout);
            this.tooltipTimeout = undefined;
        }
        if (this.onMouseMoveTooltip) {
            document.removeEventListener('mousemove', this.onMouseMoveTooltip);
            this.onMouseMoveTooltip = undefined;
        }
        if (this.tooltipDiv) {
            this.tooltipDiv.remove();
            this.tooltipDiv = undefined;
        }

        if (this.statusStackRef) {
            this.statusStackRef.remove();
            this.statusStackRef = undefined;
        }

    }
    //#region flyToLabelPoint
    private flyToLabelPoint(idEntity: string) {

        var viewSaved = this.activeLabelPointEntities[idEntity].camera
        if (viewSaved) {
            this.restoreSavedView(viewSaved, 1.5)

        } else {//Dành cho trường hợp load điểm mà bị null camera
            var entity = this.activeLabelPointEntities[idEntity].point
            this.viewer.flyTo(entity, {
                offset: new HeadingPitchRange(0.0, -0.5, 100), // Offset để điều chỉnh góc nhìn và khoảng cách
                duration: 1.0, // Thời gian bay tới
            });
        }
    }
    // Khôi phục góc nhìn cho camera
    private restoreSavedView = (obj: string, durationTime = 2) => {
        // Parse chuỗi JSON thành đối tượng
        const tempSaveCamera = JSON.parse(obj);
        if (!tempSaveCamera) {
            console.error('No saved camera view to restore');
            return;
        }
        // Di chuyển camera đến vị trí và hướng đã lưu
        this.viewer.camera.flyTo({
            destination: new Cartesian3(tempSaveCamera.position.x, tempSaveCamera.position.y, tempSaveCamera.position.z),
            orientation: {
                direction: new Cartesian3(tempSaveCamera.direction.x, tempSaveCamera.direction.y, tempSaveCamera.direction.z),
                up: new Cartesian3(tempSaveCamera.up.x, tempSaveCamera.up.y, tempSaveCamera.up.z)
            },
            easingFunction: EasingFunction.QUADRATIC_IN_OUT,
            duration: durationTime
        });
    }

    //#region saveCurrentView
    private saveCurrentView = () => {
        const camera = this.viewer.scene.camera;

        // Lưu thông tin camera (position, direction, up)
        const cameraView = {
            position: camera.position,
            direction: camera.direction,
            up: camera.up,
        };

        // Trả về chuỗi JSON chứa thông tin camera
        return JSON.stringify(cameraView);
    }

    //#region removeLabelPoint
    private removeLabelPoint = (idEntity: string) => {
        // Tìm đối tượng ban đầu
        var entity = this.activeLabelPointEntities[idEntity]?.point;
        if (entity) {
            // Xóa đối tượng trong viewer
            this.viewer.entities.remove(entity);

            // Duyệt qua danh sách để tìm và xóa các đối tượng con
            Object.keys(this.activeLabelPointEntities).forEach(key => {
                const childEntity = this.activeLabelPointEntities[key];
                if (childEntity?.parentId === idEntity) {
                    this.removeLabelPoint(key); // Gọi đệ quy để xóa các đối tượng con
                }
            });

            // Xóa đối tượng khỏi danh sách
            delete this.activeLabelPointEntities[idEntity];
        }

    }

    //#region deleteLabelFormListById
    private deleteLabelFormListById = (id: string | null): void => {
        if (!id) return;
        const removeChildren = (items: DataLabelPoint[], parentId: string): DataLabelPoint[] => {
            return items.filter(item => {
                // Nếu `item.parentID` trùng với `parentId`, xóa nó và các con của nó
                if (item.parentID === parentId) {
                    items = removeChildren(items, item.id!); // Gọi đệ quy để xóa các con
                }
                return item.id !== parentId; // Giữ lại các mục không trùng với `parentId`
            });
        };

        // Cập nhật `listLabelPoint` với danh sách mới sau khi xóa
        this.listLabelPoint = removeChildren(this.listLabelPoint, id);
        if (this.isSearching) {
            this.listSearchLabelPoint = removeChildren(this.listSearchLabelPoint, id);
        }

    };

    //#region handleDocumentEventsLabelPoint
    private handleDocumentEventsLabelPoint = (event: KeyboardEvent) => {
        if (this.isEventActive) {
            return; // Ngăn không xử lý sự kiện nếu cờ đang hoạt động
        }

        this.isEventActive = true;

        // Kiểm tra nếu phím Escape được nhấn
        if (event.key === "Escape" || event.key === "Esc") {


            // Hủy handler cho sự kiện click
            if (this.handlerClickCreateLabelPoint) {
                this.handlerClickCreateLabelPoint.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
                this.handlerClickCreateLabelPoint.destroy();
                this.handlerClickCreateLabelPoint = undefined;
            }

            // Gỡ sự kiện keydown
            this.removeDocumentEvents();
            this.viewer.scene.requestRender();

        }

        this.isEventActive = false; // Đặt lại cờ sau khi xử lý xong
    };
    //#region handleCallBackFormLabelPoint
    //Call back từ form label
    private handleCallBackFormLabelPoint = (action: ActionLabelEnum, parentRow?: DataLabelPoint) => {
        this.formLabelPoint?.setClosedCallback((status: boolean, label?: InputForm) => {

            if (status && label) {
                switch (action) {
                    case ActionLabelEnum.EditLabel:
                        const itemEdit = this.listLabelPoint.find((x: DataLabelPoint) => x.id === this.selectedRow!.id)
                        if (itemEdit) {
                            itemEdit!.displayName = label.displayName || label.name || null
                            itemEdit!.name = label.name || null
                            itemEdit!.url = label.url || null
                            itemEdit!.fontSize = label.fontSize !== undefined ? String(label.fontSize) : null
                            itemEdit!.hexColor = label.hexColor || null

                            this.handleUpdateListLabelPoint(itemEdit, ActionListLabelPoint.UPDATE)
                        }
                        this.dialog?.showModal(true)

                        break;
                    case ActionLabelEnum.CreateRoot:
                        {
                            const mapped: DataLabelPoint = {
                                id: null,
                                parentID: null,
                                name: label.name || null,
                                displayName: label.displayName || label.name || null,
                                url: label.url || null,
                                fontSize: label.fontSize !== undefined ? String(label.fontSize) : null,
                                hexColor: label.hexColor || null,
                                expand: false,
                                hasChild: false,
                                cameraView: null
                            };
                            this.createPointWithLabel(mapped, null)
                        }
                        break;
                    case ActionLabelEnum.CreateLabel:
                        {
                            const pId = parentRow?.id || null;
                            const mapped: DataLabelPoint = {
                                id: null,
                                parentID: pId,
                                name: label.name || null,
                                displayName: label.displayName || label.name || null,
                                url: label.url || null,
                                fontSize: label.fontSize !== undefined ? String(label.fontSize) : null,
                                hexColor: label.hexColor || null,
                                expand: false,
                                hasChild: false,
                                cameraView: null
                            };
                            this.createPointWithLabel(mapped, pId)
                        }
                        break;

                    case ActionLabelEnum.CreateFolder:
                        {
                            const mapped: DataLabelPoint = {
                                id: null,
                                parentID: null,
                                name: label.name || null,
                                displayName: label.displayName || label.name || null,
                                url: label.url || null,
                                fontSize: label.fontSize !== undefined ? String(label.fontSize) : null,
                                hexColor: label.hexColor || null,
                                expand: false,
                                hasChild: false,
                                cameraView: null
                            };
                            this.createFolderLabelPoint(mapped)
                        }
                        this.dialog?.showModal(true)


                        break

                    case ActionLabelEnum.EditFolder:
                        const folderEdit = this.listLabelPoint.find((x: DataLabelPoint) => x.id === this.selectedRow!.id)
                        if (folderEdit) {
                            folderEdit!.displayName = label.displayName || null
                            folderEdit!.name = label.name || null
                            folderEdit!.url = label.url || null
                            folderEdit!.fontSize = label.fontSize !== undefined ? String(label.fontSize) : null
                            folderEdit!.hexColor = label.hexColor || null
                            folderEdit!.isFolder = label.isFolder
                            this.handleUpdateListLabelPoint(folderEdit, ActionListLabelPoint.UPDATE)

                            if (!label.isFolder) {
                                this.createPointWithLabel(folderEdit, null)
                            } else {

                                this.dialog?.showModal(true)
                            }

                        }

                        break
                    case ActionLabelEnum.EditPointFolder:
                        const folderPointEdit = this.listLabelPoint.find((x: DataLabelPoint) => x.id === this.selectedRow!.id)
                        if (folderPointEdit) {
                            folderPointEdit!.isFolder = label.isFolder
                            folderPointEdit!.name = label.name || null
                            folderPointEdit!.displayName = label.displayName || null
                            folderPointEdit!.url = label.url || null
                            if (label?.isFolder === undefined || !label?.isFolder) {
                                folderPointEdit!.fontSize = label.fontSize !== undefined ? String(label.fontSize) : null
                                folderPointEdit!.hexColor = label.hexColor || null


                            } else {
                                folderPointEdit!.isFolder = true
                                folderPointEdit!.position = undefined
                                // Tìm đối tượng ban đầu
                                var entity = folderPointEdit.id ? this.activeLabelPointEntities[folderPointEdit.id]?.point : undefined;
                                if (entity) {
                                    // Xóa đối tượng trong viewer
                                    this.viewer.entities.remove(entity);
                                }
                            }
                            this.handleUpdateListLabelPoint(folderPointEdit, ActionListLabelPoint.UPDATE)
                            this.dialog?.showModal(true)
                        }
                        break;
                    default:
                        console.error("Hành động không xác định");
                }

            }
            else {
                this.dialog?.showModal(true)

            }
        })
    }

    //#region editLabelPoint
    private editLabelPoint(labelPoint: DataLabelPoint) {
        if (labelPoint.id && this.activeLabelPointEntities[labelPoint.id]) {
            if (this.activeLabelPointEntities[labelPoint.id].point) {
                this.activeLabelPointEntities[labelPoint.id].point.point.color = Color.fromCssColorString(labelPoint.hexColor!)
                this.activeLabelPointEntities[labelPoint.id].point.label.font = `${labelPoint.fontSize}px sans-serif`
                this.activeLabelPointEntities[labelPoint.id].point.label.text = labelPoint.displayName
            }
            this.activeLabelPointEntities[labelPoint.id].url = labelPoint.url || null
            this.activeLabelPointEntities[labelPoint.id].name = labelPoint.name || null
            this.activeLabelPointEntities[labelPoint.id].displayName = labelPoint.displayName || null
        }
    }

    //#region zoomLabelPoint
    private zoomLabelPoint = (labelPoint: DataLabelPoint) => {
        if (!labelPoint.cameraView) return
        this.selectedRow = labelPoint

        if (labelPoint.id) {
            this.flyToLabelPoint(labelPoint.id)
        }
    }

    //#region showHideAllLabelPoint
    private showHideAllLabelPoint(show: boolean) {

        for (const key in this.activeLabelPointEntities) {
            if (this.activeLabelPointEntities.hasOwnProperty(key)) {
                if (this.activeLabelPointEntities[key].point) {
                    this.activeLabelPointEntities[key].point.show = show;
                }

            }
        }
        this.viewer.scene.requestRender();

    }

    //#region removeLabelPointBySelected
    // Hàm xóa theo chọn từ danh sách
    private async removeLabelPointBySelected() {
        const idsToDelete = new Set<string>();

        // Đệ quy tìm tất cả ID con cần xóa
        const findChildren = (id: string) => {
            idsToDelete.add(id);
            this.listLabelPoint.forEach(item => {
                if (item.parentID === id) {
                    if (item.id) {
                        findChildren(item.id);
                    }
                }
            });
        };

        // Lấy danh sách phần tử được chọn để xóa
        const removeItem = this.listLabelPoint.filter((item) => this.selectedItems.has(item.id!));

        if (removeItem.length > 0) {
            const mes = getMessage("dialog-service-remove-select")
            const messageWithCount = mes.replace("$$$$", removeItem.length.toString());

            const dialog = new DialogService({
                containerId: this.containerId,
                typeDialog: ETypeDialogService.Warning,
                inputModal: {
                    contentHeader: getMessage("dialog-service-open-link-header"),
                    contentBody: messageWithCount
                }
            });

            // Chờ đợi người dùng nhấn nút OK hoặc Cancel
            await dialog.showModalAndWait();
            if (dialog._action === "Ok") {


                // Tìm tất cả ID cần xóa (bao gồm cả các phần tử con)
                removeItem.forEach(item => {
                    if (item.id !== null) {
                        findChildren(item.id);
                        this.removeLabelPoint(item.id);
                    }
                });

                // Xóa tất cả phần tử có ID trong danh sách cần xóa
                this.listLabelPoint = this.listLabelPoint.filter((item) => !idsToDelete.has(item.id!));

                // Nếu đang tìm kiếm, cập nhật danh sách tìm kiếm
                if (this.isSearching) {
                    this.listSearchLabelPoint = this.listSearchLabelPoint.filter((item) => !idsToDelete.has(item.id!));
                    this.renderTreelabel(this.listSearchLabelPoint);
                } else {
                    this.renderTreelabel(this.listLabelPoint);
                }

                // Cập nhật trạng thái nút
                this.toggleButtonState(`edit-label-${this.IdGenneral}`, false);
                this.toggleButtonState(`create-element-${this.IdGenneral}`, false);
                this.toggleButtonState(`cursor-update-position-${this.IdGenneral}`, false);
            }

        }
        this.viewer.scene.requestRender();

    }



    //Hàm tải json từ listLabelPoint
    private downloadJson = () => {
        if (this.listLabelPoint.length > 0) {
            const json = JSON.stringify(this.listLabelPoint, null, 2);
            const blob = new Blob([json], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'labelPoints.json';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    }

    //#region uploadJson
    //Hàm uploadjson thừ listLabelPoint
    // Cached ID sets used during upload processing to avoid repeated allocations
    private _knownIds: Set<string> | undefined;

    private buildKnownIdsForUpload(incoming?: DataLabelPoint[]) {
        const existingIds = new Set<string>(this.listLabelPoint.filter(x => x.id).map(x => x.id as string));
        const incomingIdsSet = new Set<string>((incoming || []).filter(d => d.id).map(d => d.id as string));
        this._knownIds = new Set<string>([...existingIds, ...incomingIdsSet]);
    }

    private clearKnownIdsForUpload() {
        this._knownIds = undefined;
    }
    private uploadJson = () => {

        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'application/json';
        input.onchange = async (event: Event) => {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
            if (file) {
                try {
                    this._renderLoading(true)
                    const text = await file.text();
                    let data = JSON.parse(text);
                    if (Array.isArray(data)) {
                        const incoming = data as DataLabelPoint[];
                        // Build known id set once and reuse inside loop
                        this.buildKnownIdsForUpload(incoming);

                        data.forEach((item: DataLabelPoint) => {
                            if (!item.hexColor) {
                                const extKey = typeof item.ext === 'string' ? item.ext : '';
                                item.hexColor = BASE_COLORS[extKey.toLowerCase()] || "#F4B400";
                            }
                            if (!item.fontSize) {
                                item.fontSize = "14"
                            }
                            if (!item.displayName) {
                                item.displayName = item.name
                            }

                            // Nếu parentID không tồn tại trong list hiện có hoặc trong chính dữ liệu upload,
                            // chuẩn hoá về null. Sử dụng cached _knownIds để tránh tạo set nhiều lần.
                            const parentId = item.parentID;
                            if (parentId == null || !this._knownIds || !this._knownIds.has(parentId)) {
                                item.parentID = null;
                            }

                            const compareId = this.listLabelPoint.find((x: DataLabelPoint) => x.id === item.id)
                            if (compareId) {
                                data = data.filter((x: DataLabelPoint) => x.id !== compareId.id);
                            } else {
                                item.expand = false
                                this.handleUpdateListLabelPoint(item, ActionListLabelPoint.ADD);

                            }
                        });

                        await this.createLabelPointFromUrl("", true, data, true);
                    } else {
                        alert('Dữ liệu không hợp lệ!');
                    }
                } catch (error) {
                    console.error('Error reading or parsing file:', error);
                    alert('Đã xảy ra lỗi khi đọc hoặc phân tích tệp!');
                } finally {
                    // clear cached id sets used during upload
                    this.clearKnownIdsForUpload();
                    this._renderLoading(false)

                }
            }
            }
        };
        input.click();
        this.viewer.scene.requestRender();

    };


    //#region requestJsonRenderTree
    requestJsonRenderTree = async (listLabelPoint: DataLabelPoint[], isShow: boolean = false) => {
        let flagCompare = false
        this._renderLoading(true)

        listLabelPoint?.forEach((item: DataLabelPoint) => {
            const compareId = this.listLabelPoint.find((x: DataLabelPoint) => x.id === item.id)
            if (compareId) {
                listLabelPoint = listLabelPoint.filter((x: DataLabelPoint) => x.id !== compareId.id);
                flagCompare = true
            } else {
                item.expand = false
                this.handleUpdateListLabelPoint(item, ActionListLabelPoint.ADD);

            }
        });
        await this.createLabelPointFromUrl("", true, listLabelPoint, isShow);
        if (flagCompare) {
            this.renderTreelabel(this.listLabelPoint)
        }
    }

    //#region _renderLoading
    private _renderLoading = (isShow: boolean) => {
        if (this.containerUl) {
            if (isShow) {
                this.containerUl.innerHTML = `
        <div id="loading-lable-${this.IdGenneral}" style ="width:100%;height:100%;display:flex;justify-content:center;align-items:center">   
        <img class="dpu-loading-animation" src="${loadingGif}" alt="Loading..." width="30" height ="30" />
        </div>
   
      `
            } else {
                document.querySelector(`#loading-lable-${this.IdGenneral}`)?.remove()
            }
        }
    }
}